import { useMutation } from "react-query";
import { deleteWipMeasurements, deleteMeasurements } from "components/measuring/lib/measuring-data";

export const useRemovePosition = () => {
    return useMutation(async ({ measuringWipKey, measurements }) => {
        const savePromises = measurements.map((m) => {
            if (measuringWipKey) {
                deleteWipMeasurements(measuringWipKey, m.key);
            }

            return deleteMeasurements(m.key);
        });

        return Promise.all(savePromises);
    });
};
